exports = module.exports = require("../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-6a5b2496] .el-radio.is-bordered{padding:0 20px}[data-v-6a5b2496] .el-radio__input{cursor:pointer;vertical-align:-2px}[data-v-6a5b2496] .el-switch__label--left{background:transparent!important}.label[data-v-6a5b2496]{display:inline-block;font-size:14px;text-align:right;padding-right:12px;box-sizing:border-box;vertical-align:top}.label[data-v-6a5b2496] .el-icon--right{margin-left:2px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader!./node_modules/_vue-loader@13.7.3@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6a5b2496","scoped":true,"hasInlineConfig":false}!./node_modules/_sass-loader@7.3.1@sass-loader/dist/cjs.js!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=styles&index=0!./UI/Radio/index.vue
// module id = 632
// module chunks = 0